import { Component, inject } from '@angular/core';
import { table, CacTableComponent } from '@controladad/ng-base';
import { AuthStore, cacTableStatusCol, UserApiService } from '@core';

@Component({
  selector: 'lib-vendor-users',
  standalone: true,
  imports: [CacTableComponent],
  templateUrl: './vendor-users.component.html',
  styleUrl: './vendor-users.component.scss',
})
export class VendorUsersComponent {
  private readonly usersApi = inject(UserApiService);
  private readonly authStore = inject(AuthStore);

  table = table({
    itemsFn: this.usersApi.getVendorAdapter(),
    selectable: true,
    view: {
      itemName: 'Vendor',
      title: 'Vendor',
    },
    columns: {
      // NOT stated on ticket, but probably will be asked >>
      // id: { label: 'ID', sortable: true, filterable: true },
      vendorName: {
        label: 'Vendor Name',
        sortable: 'VendorName',
        filterable: 'VendorName',
      },
      email: { label: 'Email', sortable: true, filterable: true },
      status: cacTableStatusCol(),
    },

    actions: this.authStore.isRestrictedAdmin() ? [] : [
      {
        type: 'icon',
        content: 'edit',
        action: (item) => dialog$.vendorUser({ vendor: item }).afterSubmit(),
      },
    ],
    bulkActions: [
      {
        content: 'Active',
        action: (items) =>
          dialog$
            .prompt({
              title: 'Are you sure you want to Activate the selected vendor(s)?',
              yesButtonText: 'Yes, Activate',
              message: 'This action will Activate the selected vendor(s).',
            })
            .action(() => this.usersApi.changeVendorStatus({ ids: items.map((i) => i.userId), status: 1 })),
      },
      {
        content: 'Deactivate',
        action: (items) =>
          dialog$
            .prompt({
              title: 'Are you sure you want to Deactivate the selected vendor(s)?',
              yesButtonText: 'Yes, Deactivate',
              message: 'This action will Deactivate the selected vendor(s).',
            })
            .action(() => this.usersApi.changeVendorStatus({ ids: items.map((i) => i.userId), status: 0 })),
      },
    ],
    events: this.authStore.isRestrictedAdmin() ? undefined : {
      add: () => dialog$.vendorUser({}).afterSubmit(),
    },
  });
}
